import { TriggerParams } from '@/models/TriggerParams';
import { BuildConfigurationType } from '../types';

const getBuildParams = (data: BuildConfigurationType): TriggerParams => {
  const {
    branch,
    buildConfigType,
    commitHash,
    commitMessage,
    environments,
    licensePoolId,
    machineTypeId,
    pipelineableId,
    secrets,
    stack,
    tag,
    priority,
  } = data;

  const buildParams: TriggerParams = {};

  if (branch) {
    buildParams.branch = branch.trim();
  }
  if (commitMessage) {
    buildParams.commitMessage = commitMessage;
  }
  if (pipelineableId) {
    if (pipelineableId.includes('pipeline#')) {
      buildParams.pipelineId = pipelineableId.replace('pipeline#', '');
    } else {
      buildParams.workflowId = pipelineableId.replace('workflow#', '');
    }
  }

  if (buildConfigType === 'advanced') {
    if (commitHash) {
      const ch = commitHash.trim();
      if (ch.length) {
        buildParams.commitHash = ch;
      }
    }
    if (environments && environments.length) {
      const emptyIsFiltered = environments.filter((value) => !!value.mappedTo && !!value.value);
      if (emptyIsFiltered.length > 0) {
        buildParams.environments = emptyIsFiltered;
      }
    }
    if (licensePoolId) {
      buildParams.licensePoolId = licensePoolId;
    }
    if (machineTypeId) {
      buildParams.machineTypeId = machineTypeId;
    }
    if (secrets && secrets.length) {
      const emptyIsFiltered = secrets.filter((value) => !!value.mappedTo && !!value.value);
      if (emptyIsFiltered.length > 0) {
        buildParams.secrets = {};
        emptyIsFiltered.forEach(({ mappedTo, value }) => {
          if (buildParams.secrets) {
            buildParams.secrets[mappedTo] = value;
          }
        });
      }
    }
    if (stack) {
      buildParams.stack = stack;
    }
    if (tag) {
      const t = tag.trim();
      if (t.length) {
        buildParams.tag = t;
      }
    }

    if (priority) {
      buildParams.priority = +priority;
    }
  }

  return buildParams;
};

export default getBuildParams;
